import React from 'react'
import { css } from '@emotion/core'
import Scrim from '@divvy-web/skylab.scrim'
import { bool } from 'prop-types'
import useGetBillProduct from '../../hooks/useGetBillProduct'

const LoadingLogo = ({ isShowing }) => {
  const { loadingLogo } = useGetBillProduct()
  return (
    <Scrim
      useEscHandler
      css={scrimStyles}
      isShowing={isShowing}
    >
      <div css={loadingLogoStyles}>
        <div className='loading-logo-img-wrapper'>
          <img
            alt='divvy-loading-logo'
            src={`https://app.divvy.co/assets/animations/${loadingLogo}.gif`}
          />
        </div>
      </div>
    </Scrim>
  )
}
const scrimStyles = ({ skylab }) => css`
  z-index: calc(${skylab.zIndex.popSheet} + 1);
`

const loadingLogoStyles = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .loading-logo-img-wrapper {
    background: white;
    border-radius: 50%;
    img {
      max-width: 136px;
    }
  }
`
export default LoadingLogo

LoadingLogo.defaultProps = { isShowing: false }
LoadingLogo.propTypes = {
  isShowing: bool,
}
